import { z } from "zod";
import { ColumnSchema, ViewSchema } from "./views";

export enum TransactionColumn {
    DATE = "date",
    AMOUNT = "amount",
    DESCRIPTION = "description",
    CATEGORY = "category",
    ACCOUNT = "account",
    COUNTERPARTY = "counterparty",
    NOTE = "note",
    RECEIPTS = "receipts",
    SPLIT = "split",
    CLASSES = "classes",
    ENTITY = "entity",
    ACTIONS = "actions",
}

export const TransactionViewSchema = ViewSchema.extend({
    columns: z.array(
        ColumnSchema.extend({
            id: z.nativeEnum(TransactionColumn),
        }),
    ),
});

export type TransactionView = z.infer<typeof TransactionViewSchema>;
